import { Component, OnInit, Input } from '@angular/core';
import { BcAccountClientService } from '../../service/bc-account-client.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { DialogService } from "ng2-bootstrap-modal";
import { CommentModalComponent } from "./comment-modal/comment-modal.component";
import { saveAs } from 'file-saver';
import * as globalConst from './../../../../../constants';
import { Subscription } from 'rxjs';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';

@Component({
	selector: 'app-bc-billing-list-integral',
	templateUrl: './bc-billing-list-integral.component.html',
	styleUrls: ['./bc-billing-list-integral.component.scss']
})
export class BcBillingListIntegralComponent implements OnInit, OnDestroy {


	@Input('client') client = [];
	@Input('isCurrentClient') isCurrentClient = false;

	public resultCount: number = 0;
	public orderby: string = "VencimentoOriginal";
	public sort: string = "asc";
	private billingList: any[] = [];
	public permissoes: any[] = [];
	public qtdPorPaginaCustom: number = 10;
	public qtdPorPagina: number = 10;
	currentPage: number = 0;
	private CodigoPrincipal;

	
	//control changes on titles
	private proposalSubcription = new Subscription;

	constructor(private bcAccountClientService: BcAccountClientService, private flashMessagesService: FlashMessagesService, private dialogService: DialogService) { }

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		if (this.isCurrentClient) {
			this.loadIntegralBilling(this.client, 0, this.qtdPorPagina);
		}

		this.proposalSubcription = this.bcAccountClientService.billingChaged.subscribe(change =>{
			this.loadIntegralBilling(this.client, this.currentPage, this.qtdPorPagina);
		});

		this.CodigoPrincipal = this.client["CodigoPrincipal"];
	}

	ngOnDestroy() {
		this.proposalSubcription.unsubscribe();
	}

	expandClient(client) {
		var target = "#collapseIntegrante" + client.CodigoPrincipal;
		if ($(document).find("a[href='"+target+"'").attr("aria-expanded") === "false") {
			if (!this.isCurrentClient) {
				this.loadIntegralBilling(this.client, 0, this.qtdPorPagina);
			}
		}
	}

	changePerPage(value) {
		this.qtdPorPagina = value;
		this.loadIntegralBilling(this.client, 0, this.qtdPorPagina);
	}

	

	tableScroll(){
		$(".biling-list"+this.CodigoPrincipal + " thead tr th:nth-child(1)").css("left", $(".titlesDiv").scrollLeft()-1);
		$(".biling-list"+this.CodigoPrincipal + " tbody tr td:nth-child(1)").css("left", $(".titlesDiv").scrollLeft()-1);
	}

	loadIntegralBilling(client, page, qtdPaginas) {

		page = page * this.qtdPorPagina;
		
		$(".biling-list" + client.CodigoPrincipal + " thead th:first-child input[type='checkbox']").prop("checked", false);

		var clientID = client.ContaClienteId;

		this.bcAccountClientService.getTitulos(clientID, this.orderby, this.sort, page, qtdPaginas).subscribe(result => {
			if (result.Success) {
				this.billingList = result.Result.Titulos;

				console.log("Billing List", this.billingList);

				this.bcAccountClientService.currentClientHaveTitles = (this.isCurrentClient && this.billingList) ? true : false;

				if (this.billingList && this.bcAccountClientService.selectedBillings) {
					for (var i = 0; i < this.billingList.length; i++) {
						for (var j = 0; j < this.bcAccountClientService.selectedBillings.length; j++) {
							if (this.billingList[i].NumeroDocumento === this.bcAccountClientService.selectedBillings[j].NumeroDocumento &&
								this.billingList[i].Linha === this.bcAccountClientService.selectedBillings[j].Linha &&
								this.billingList[i].AnoExercicio === this.bcAccountClientService.selectedBillings[j].AnoExercicio) {
								this.billingList[i].checked = true;
							}
						}
					}
					this.resultCount = result.Count;
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	exportExcel(clientID) {
        this.bcAccountClientService.exportExcel(clientID).subscribe(blob => {
            if (blob) {
                saveAs(blob, this.client['Nome'].replace(/[^a-zA-Z ]+/gi, '').replace(/[ ]+/g, '_') + ".xlsx");
            } else {
                this.flashMessagesService.show("Problema ao baixar o arquivo", { cssClass: 'alert-danger', timeout: 6000 });
            }
        }, error => {
            console.log(error);
        });
    }

	setBilling(e, obj) {
		obj.ContaClienteId = this.client['ContaClienteId'];
		this.bcAccountClientService.setBilling(e.target.checked, obj);
	}

	selectAll(e, cod) {
		var target = $(".biling-list" + cod);

		target.find("tbody tr").each(function() {
			if (e.target.checked) {
				if (!$("td:first-child input[type='checkbox']", this).is(':checked')) {
					$("td:first-child input[type='checkbox']", this).trigger("click");
				}
			} else {
				if ($("td:first-child input[type='checkbox']", this).is(':checked')) {
					$("td:first-child input[type='checkbox']", this).trigger("click");
				}
			}
		});
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.loadIntegralBilling(this.client, this.currentPage, this.qtdPorPagina);
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.loadIntegralBilling(this.client, $event, this.qtdPorPagina);
	}

	getSelectedTitleVPClient(clientID) {

		let sum = 0;

		for (let i = 0; i < this.bcAccountClientService.selectedBillings.length; i++)
			if (this.bcAccountClientService.selectedBillings[i].ContaClienteId === clientID) {
				sum += this.bcAccountClientService.selectedBillings[i].ValorInterno;
			}


		return sum;
	}

	getSelectedTitleVJClient(clientID) {
		let sum = 0;

		for (let i = 0; i < this.bcAccountClientService.selectedBillings.length; i++)
			if (this.bcAccountClientService.selectedBillings[i].ContaClienteId === clientID)
				sum += this.bcAccountClientService.selectedBillings[i].ValorJuros;

		return sum;
	}

	getSelectedTitleVCClient(clientID) {
		let sum = 0;

		for (let i = 0; i < this.bcAccountClientService.selectedBillings.length; i++)
			if (this.bcAccountClientService.selectedBillings[i].ContaClienteId === clientID)
				sum += this.bcAccountClientService.selectedBillings[i].ValorAtual;

		return sum;
	}

	openCommentModal(item) {
		let disposable = this.dialogService.addDialog(CommentModalComponent, {
			guid: item.NumeroDocumento + "/" + item.Linha + "/" + item.AnoExercicio + "/" + item.Empresa.replace(' ', ''),
			title: "Comentários",
			numeroDocumento: item.NumeroDocumento,
            linha: item.Linha,
            anoExercicio: item.AnoExercicio,
            empresa: item.Empresa
		},
			{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
			.subscribe((isConfirmed) => {
				if (isConfirmed) {

				}
			});

	}

}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-billing-list/bc-billing-list-integral/bc-billing-list-integral.component.ts